import React from 'react';
import PropTypes from 'prop-types';
import { Box, ModalLauncher } from '@metarouter-private/mr-mui';
import SendEventButton from './SendEventButton';
import ConfirmSendEventModal from './ConfirmSendEventModal';

export default function SendEventModalLauncher({ onConfirm, integrationName, clusterName }) {
  const modalProps = { onConfirm, integrationName, clusterName };
  return (
    <Box>
      <ModalLauncher Launcher={SendEventButton} Modal={ConfirmSendEventModal} modalProps={modalProps} />
    </Box>
  );
}

SendEventModalLauncher.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  integrationName: PropTypes.string.isRequired,
  clusterName: PropTypes.string.isRequired,
};
